import { translate } from "../../Services/translation";
import React from "react";
import DeliveryMethods from "./DeliveryMethods";
import PartialShipping from "./PartialShipping";

function DeliveryInformation({ freight, paymentMethod }) {

    return (
        <div>
            <p className="checkout__section-title">{translate('checkout.form.deliveryinformation')}</p>
            <div className="card">
                <div className="card__body card__body--large">
                    <div className="checkout__form-container">
                        {
                            freight && <DeliveryMethods freight={freight}/>
                        }
                    </div>

                    {freight && <PartialShipping deliveryOptions={freight.deliveryOptions}/>}
                </div>
            </div>
            {
                paymentMethod === 'credit-card' &&
                <p className="checkout__customs-text">{translate('checkout.customs.text')}</p>
            }
        </div>
    )
}

export default DeliveryInformation;
